module.exports = __webpack_public_path__ + "static/media/Karthik Manivachagam.cf0e0b28.png";